import clsx from "clsx";

export type ClassList = Array<string | undefined>;

export const cl = (classList: ClassList): string | undefined => clsx(classList);

export const addClassToList = (classList: ClassList, classes: ClassList | string | undefined): void =>
{
    if (classes !== undefined)
    {
        if (Array.isArray(classes))
        {
            classList.push(...classes);
        }
        else
        {
            classList.push(classes);
        }
    }
}